import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ progress }) => {
    const roundedProgress = Math.round(progress);
  return (
    <div className="loading-spinner-container">
    {progress > 0 ? (
      <>
      <h3>Loading...</h3>
      <div className="loading-spinner">
        <div className="loading-spinner-inner" style={{ width: `${progress}%` }}>{roundedProgress}% complete</div>
      </div>
      </>
    ): ( <p>Nothing to Display</p>)}
    </div>
    
  );
};

export default LoadingSpinner;
